import { createContext, useContext, useEffect, useState } from 'react';
const NewMessagesContext = createContext({
  newMessages: [],
  setNewMessages: () => undefined
});
export const useNewMessagesMeta = () => {
  const context = useContext(NewMessagesContext);
  if (context === null) {
    throw new Error('Could not get new messages context. Did you forget to use NewMessagesProvider?');
  }
  return context;
};
export function NewMessagesProvider({
  children
}) {
  const [newMessages, setNewMessages] = useState([]);
  const value = {
    newMessages,
    setNewMessages
  };
  useEffect(() => {
    return () => {
      setNewMessages([]);
    };
  }, []);
  return <NewMessagesContext.Provider value={value}>
			{children}
		</NewMessagesContext.Provider>;
}